/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class QueueScheduleRowMobileComponent extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let date = moment(),
            isoDate = null,
            time = [],
            startTime = '',
            formattedTime = null,
            constants = this.props.app.config.constants,
            days = [
                constants.FS_SUNDAY,
                constants.FS_MONDAY,
                constants.FS_TUESDAY,
                constants.FS_WEDNESDAY,
                constants.FS_THURSDAY,
                constants.FS_FRIDAY,
                constants.FS_SATURDAY,
            ],
            categoryHint = null,
            categoryTag = null,
            editor = null,
            rowToggleIcon = (
                <i className="icon ion-chevron-right"></i>
            );

        if (this.props.schedule.s_startTime) {

            startTime = this.props.schedule.s_startTime;

            time = startTime.split(':');

            date.set({hour: time[0], minute: time[1], second: time[2]});

            isoDate = date.toISOString();
            formattedTime = date.format('h:mm A');

        }

        if (parseInt(this.props.schedule.s_tagID)) {
            let category = null;
            for (let i = 0; i < this.props.categoryList.length; ++i) {
                if (this.props.categoryList[i].id == this.props.schedule.s_tagID) {
                    category = this.props.categoryList[i];
                }
            }
            if (category && category !== null) {
                let textColor = '',
                    hex = category.color.replace("#", ""),
                    r = parseInt(hex.slice(0, 2), 16),
                    g = parseInt(hex.slice(2, 4), 16),
                    b = parseInt(hex.slice(4, 6), 16);
                // stolen from stackoverflow...
                textColor = ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#FFFFFF';

                categoryTag = (
                    <div className="category-tag" style={{
                            "width": '20px',
                            "height": "20px",
                            "border": '1px solid ' + category.color,
                            'backgroundColor': category.color,
                            'color': textColor,
                            "marginLeft": "5px"}}>
                    </div>
                );

                categoryHint = (
                    <div className="category-hint" style={{'color': category.color}}>
                        {category.name}
                        {categoryTag}
                    </div>
                );
            }

        }

        if (this.props.editingSchedule === this.props.schedule.s_id) {
            rowToggleIcon = (<i className="icon ion-chevron-down"></i>)
        }

        return (
            <div className="mobile-schedule-row" onClick={this.props.toggleHandler} data-scheduleid={this.props.schedule.s_id} role="button" aria-label="toggle tools">
                <div className="schedule-info-mobile">
                    <div className="queue-row-toggle" >
                        {rowToggleIcon}
                    </div>
                    <div className="schedule-time">
                        {formattedTime}
                    </div>
                    <div className="schedule-edit">
                        <i className="icon ion-edit"></i>
                    </div>
                </div>
                {categoryHint}
            </div>
        );
    }
}

QueueScheduleRowMobileComponent.displayName = "QueueScheduleRowMobileComponent";

QueueScheduleRowMobileComponent.propTypes = {

};

QueueScheduleRowMobileComponent.defaultProps = {

};

export default QueueScheduleRowMobileComponent;
